<template>
  <el-container class="report-design" ref='design'>
    <!--头部信息-->
    <el-header height="45px" class="report-design-header">
      <div class="report-design-header-name">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ parseInt(selectPlate) === 5 ? '自定义页面' : '报表设计' }}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="!nameAttr.showNameInput">{{report.name || '未命名'}}<i class="el-icon-edit-outline name" @click="changeName"></i></el-breadcrumb-item>
           <el-input class="name-input" ref="nameInput" v-else v-model="report.name" @change="saveName" @blur="saveName"  @keyup.esc.native="recallName"></el-input>
        </el-breadcrumb>
      </div>
      <div class="header-buttons">
        <el-dropdown split-button type="primary" @click="publish">
          <i v-if="saveAccomplish" class="el-icon-loading"></i>
          保存
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a @click="saveAndClose">保存并关闭</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class='fullScreen' :title="isFullScreen?`退出全屏`:`全屏`" :class="[isFullScreen?'exit':'']"
              @click="toggleFullScreen"></span>
      </div>
    </el-header>
    <!--报表设计内容-->
    <el-container ref="report2" v-if="[0,1,2,3,4,7].includes(parseInt(selectPlate))&&isRouterAlive" class="report-design-container">
      <!--报表设计左侧区域-->
      <div class="report-component-aside">
        <div class="left-panel">
          <div :class="['bottom-panel', selectPlate > 1 && 'graph-panel']">
            <div class="panel-switch">
              <!--左侧面板有两种东西, 一种是选择选择数据列, 一种是报表属性-->
              <data-list ref='dataList'
                         @resetReport="resetReport"
                         v-show="leftPanel.type===''"
                         @scrollRight="scrollRight"
                         :id="this.reportId"
                         :reportType="this.report.reportType"
                         :selectPlate="selectPlate"
                         @drawGraph="drawGraph"
                         @updateBillboard="updateBillboard"
                         :billboardProperties="billboardProperties"
                         :graphSettingPrpos="graphSettingPrpos"></data-list>
              <component ref="reportcPanelAttr" :is="leftPanel.type" :id="leftPanel.id" :report="report" :contractEnable="contractEnable"></component>
            </div>
          </div>
        </div>
      </div>
      <!--报表设计右侧区域-->
      <el-main>
        <div class="right-panel">
          <!--筛选面板-->
          <div v-if="[0,1,2,3,4].includes(selectPlate)" class="report-filter">
            <report-filter ref="reportFilter" :filters="report.filters" :selectPlate="selectPlate"></report-filter>
          </div>
          <!--功能报表、数据报表-->
          <div v-if="selectPlate <= 1" class="report-main">
            <div class="report-main-title">
              <span class="sort-column" @click='sortColumn' v-if='report.mainTableId'>
                <i class="el-icon-sort"></i>列序
              </span>
              <el-tabs :value="report.mainTableId" type="card" @tab-remove="removeChildren"
                       @tab-click='openchildrenTablePanel' v-if='report.mainTableId'>
                <el-tab-pane v-for="item in children" :key="item.id" :label="item.name" :name="item.id"
                             :closable='item.name!=="主表单"'>
                </el-tab-pane>
                <el-tab-pane name="添加">
                  <span slot="label" @click='addChildren' title="添加新子表" class="add-children">
                   <i class="el-icon-circle-plus-outline"></i>
                  </span>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="report-mian-content">
              <main-definition-table ref="maintable" :repor="report"></main-definition-table>
            </div>
          </div>
          <div v-else :class="selectPlate !== 7?'graph-main':'billboard-main'">
            <div v-if="selectPlate !== 7" class="graph-title">
              <span>{{getDesignName}}</span>
            </div>
            <div :class="selectPlate !== 7?'graph-map':'billboard-map'">
              <template v-if="this.selectPlate === 2">
                <histogram-report ref="histogramReportDesign" v-if="graphData.length > 0 && _provided.reportService.report.norm" :graphData="graphData" :norm="_provided.reportService.report.norm.norm" :dimensionality="_provided.reportService.report.dimensionality"></histogram-report>
              </template>
              <template v-if="this.selectPlate === 3">
                <pie-report ref="pieReportDesign" v-if="graphData.length > 0 && _provided.reportService.report.norm" :graphData="graphData" :norm="_provided.reportService.report.norm.norm" :dimensionality="_provided.reportService.report.dimensionality"></pie-report>
              </template>
              <template v-if="this.selectPlate === 4">
                <line-report ref="lieReportDesign" v-if="graphData.length > 0 && _provided.reportService.report.norm" :graphData="graphData" :norm="_provided.reportService.report.norm.norm" :dimensionality="_provided.reportService.report.dimensionality"></line-report>
              </template>
              <template v-if="this.selectPlate === 7">
                <billboard :billboardData="billboardData" :billboardProperties=report.kanBanProperties  :isRuntime="false" ref="lieReportDesign"></billboard>
              </template>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-container v-if="parseInt(selectPlate)===5" class="report-design-container">
      <custom-page-design ref="customPageDesign" v-if="isBloated" :choiceControls="customPageParams.controls"></custom-page-design>
    </el-container>
    <form-design-dialog v-if="dialogPage.dialog.visible" :page="dialogPage" @setDefinitionName="setDefinitionName"></form-design-dialog>
  </el-container>
</template>

<script>
import ReportService from '../../../store/report/reportService'
import Report from '../../../store/report/report'
import MainDefinitionTable from './main-definition-table.vue'
import ButtonPanel from './button-panel.vue'
import ChildrenTablePanel from './children-table-panel.vue'
import DataList from './report-data-list'
import ReportFilter from './report-filter'
import FilterPanel from './filter-panel'
import ColumnPanel from './column-panel'
import Children from '@/store/report/children.js'
import {fullscreenMixin} from '../../shared/designMixins/mixins'
import ReportRuntime from '@/components/report/runtime/report-runtime.vue'
import FormDesignDialog from '../../form/design/form-design-dialog.vue'
import FormService from '@/store/form/formService'
import HistogramReport from '../../public/graphReport/histogram-report'
import lineReport from '../../public/graphReport/line-report'
import pieReport from '../../public/graphReport/pie-report'
import customPageDesign from './customPage/custom-page-design'
import {UUID} from '@/plugins/common'
import billboard from './customPage/billboard'
import Controls from './customPage/assets/js/controls'

export default {
  name: 'ReportDesign',
  provide () {
    return {
      formService: new FormService(),
      reportService: new ReportService(),
      needLoad: this.needLoadObj,
      reportComment: {changeColumn: false, changeFiter: false, changeAttr: false}
    }
  },
  props: ['id', 'dataSourceReport', 'selectPlate', 'reportValue', 'designDialog'],
  data () {
    return {
      report: new Report(),
      previousReport: null,
      leftPanel: {type: '', id: ''},
      page: {},
      options: {
        dataSourceReports: [],
        leftPanel: {type: '', id: ''}
      },
      dialogPage: {
        reportName: '',
        reportId: '',
        dialog: {visible: false, title: '', view: ''}
      },
      needLoadObj: {value: 0, flag: false},
      routerList: [],
      saveAccomplish: false,
      graphData: [],
      graphSettingPrpos: {},
      customPageParams: {
        id: '',
        name: '',
        controls: [],
        reportType: '5',
        securityEnable: false,
        advancedFilter: false,
        conditionsRequired: false,
        appSwitch: false,
        dataSourceReport: false
      },
      isBloated: false,
      isRouterAlive: true,
      //  报表id。给左侧下拉选项用
      reportId: this.id,
      contractEnable: false,
      nameAttr: {
        showNameInput: false,
        oldName: ''
      },
      //  看板信息
      billboardData: [],
      //  看板左侧属性，只有编辑时才会传入。作为编辑的判断
      billboardProperties: {}
    }
  },
  mixins: [fullscreenMixin],
  components: {
    DataList,
    ButtonPanel,
    ChildrenTablePanel,
    MainDefinitionTable,
    ReportFilter,
    FilterPanel,
    ReportRuntime,
    FormDesignDialog,
    ColumnPanel,
    HistogramReport,
    lineReport,
    pieReport,
    customPageDesign,
    billboard
  },
  async created () {
    // 自定义页面和报表已经基本无关系了。
    if ([0, 1, 2, 3, 4, 7].includes(parseInt(this.selectPlate))) {
      //  封装：加载报表
      this.loadReport()
    } else if (parseInt(this.selectPlate) === 5) {
      this.report.reportType = 5
      if (this.id !== '') {
        await this.initCustomPage().then(data => {
          data.controls = this.disposeHistoryData(JSON.parse(data.controls))
          this.report.name = data.name
          if (this.designDialog.isResetReport) {
            data.controls = []
          }
          this.customPageParams = data
          this.$nextTick(res => {
            this.isBloated = true
            // 自定义页面创建时保存一份旧数据用来做对比
            this.reportValue.oldValue = JSON.stringify(this.$_.cloneDeep(this.customPageParams))
            this.reportValue.newValue = this.customPageParams
          })
        })
      } else {
        this.isBloated = true
      }
    }
  },
  methods: {
    loadReport () {
      this._provided.reportService.report = this.report
      this._provided.reportService.options = this.options
      this.initReport()
        .then(async () => {
          // 判断电子合同按钮是否可用
          await this.isContractEnable()
          this._provided.reportService.options.leftPanel = this.leftPanel
          // 加载表单和流程信息, 主要用于按钮指向问题
          this._provided.reportService.loadForm()
          this._provided.reportService.loadProcesse()
          // 加载报表分类信息
          if (this.dataSourceReport !== undefined) {
            this.report.dataSourceReport = this.dataSourceReport
          }
        })
      this.fullscreenchange()
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    // resizeWidth (data, ratio) {
    //   data = this.$_.merge([], data)
    //   data.forEach(d => {
    //     d.position.left = d.position.left * ratio
    //     d.position.top = d.position.top * ratio
    //     d.width = d.width * ratio - 20
    //     d.height = d.height * ratio - 20
    //   })
    //   return data
    // },
    initCustomPage () {
      return new Promise(resolve => {
        this.$axios.get(`/report-api/report/definition/${this.id}?type=edit`).then(res => {
          resolve(res.data)
        })
      })
    },
    initReport (id = '') {
      return new Promise((resolve, reject) => {
        let reportId = id === '' ? this.id : id
        this._provided.reportComment = {changeColumn: false, changeFiter: false, changeAttr: false}
        try {
          // 点击过预览,取vuex的数据先
          if (reportId) {
            this.$axios.get(`/report-api/report/definition/${reportId}?type=edit`)
              .then(res => {
                // 如果没有 reportType的话默认值为 0
                if (res.data.reportType === null || res.data.reportType === undefined) {
                  res.data.reportType = '0'
                }
                // 组合报表的默认选中自己
                if (!res.data.groupReportData || !res.data.groupReportData.length) {
                  res.data.groupReportData = []
                  res.data.groupReportData.unshift({id: res.data.id, name: res.data.name})
                }
                if (res.data.mergeSame) {
                  res.data.mergeSame = JSON.parse(res.data.mergeSame)
                }
                if (res.data.editColumns) {
                  res.data.editColumns = JSON.parse(res.data.editColumns)
                }
                this.report.load(Report.create(res.data))
                this.previousReport = this.$_.cloneDeep(this.report)
                this.reportValue.oldValue = JSON.stringify(this.$_.cloneDeep(this.report))
                this.reportValue.newValue = this.report
                this._provided.reportService.loadTarget(res.data.mainTableId)
                this.dialogPage.reportName = res.data.name
                this.$emit('changeSelectPlate', parseInt(res.data.reportType))
                if (this.designDialog.isResetReport) {
                  this._provided.reportService.reset()
                } else {
                  //  图标报表
                  if (parseInt(res.data.reportType) > 1 && parseInt(res.data.reportType) !== 7) {
                    this.graphSettingPrpos = {
                    // 维度
                      dimension: {
                        selectList: this.$_.merge([], res.data.dimensionality)
                      },
                      // 指标
                      index: {
                        selectList: Object.keys(this.$_.cloneDeep(res.data.norm)).length > 0 ? [this.$_.cloneDeep(res.data.norm)] : []
                      }
                    }
                  }
                  //  看板
                  if (parseInt(res.data.reportType) === 7) {
                    //  看板二次编辑时渲染数据
                    this.billboardProperties = this.$_.merge([], res.data.kanBanProperties)
                  }
                }
                resolve()
              })
          } else {
            this.report = Report.create()
            // 组合报表的默认选中自己
            if (!this.report.groupReportData || !this.report.groupReportData.length) {
              this.report.groupReportData = []
              this.report.groupReportData.unshift({id: this.report.id, name: this.report.name})
            }
            this.previousReport = this.$_.cloneDeep(this.report)
            this._provided.reportService.report = this.report
            this.report.reportType = this.selectPlate
            resolve()
          }
        } catch (e) {
          reject(e)
        }
      })
    },
    // 电子合同按钮是否可用
    isContractEnable () {
      this.$axios.get('/system-api/contract/isEnable').then(res => {
        this.contractEnable = res.data
      })
    },
    addChildren () {
      let children = new Children({name: '新子表'})
      this._provided.reportService.createOrUpdate(children)
      this.page.tables = false
    },
    openchildrenTablePanel (tab) {
      if (tab.label === '主表单' || tab.name === '添加') {
        this.closeAttr()
      } else {
        this.needLoadObj.flag = true
        this._provided.reportService.openPanel(tab.name, 'children-table-panel')
      }
    },
    removeChildren (tab) {
      let child = this.report.children.find(m => m.id === tab)
      child && this._provided.reportService.delete(child)
      this.closeAttr()
    },
    scrollRight () {
      this.$refs.maintable && this.$refs.maintable.scrollRight()
    },
    sortColumn () {
      this.$refs.maintable && this.$refs.maintable.sortColumn()
    },
    closeAttr () {
      this._provided.reportService.closePanel()
    },
    isCloseReportAttr () {
      if (this.selectPlate > 1) {
        if (!this.$refs.dataList.$data.isSaveGraphAttr) {
          this.$message({
            message: '请先保存报表属性',
            center: true,
            duration: 3000,
            customClass: 'without-execute-dialog'
          })
          return Promise.reject(new Error('请先保存报表属性'))
        }
      }
      if (this.$refs.reportcPanelAttr || this.$refs.dataList.$refs.reportAttr) {
        this.$message({
          message: '请先保存报表属性',
          center: true,
          duration: 3000,
          customClass: 'without-execute-dialog'
        })
        return Promise.reject(new Error('请先保存报表属性'))
      } else {
        return Promise.resolve()
      }
    },
    handleGroupReportName () {
      let currentReport = this.report.groupReportData && this.report.groupReportData.find(n => n.id === this.report.id)
      if (currentReport) {
        currentReport.name = this.report.name
      }
    },
    // 处理每次更新的备注信息
    handleUpdateComment () {
      let comment = ''
      if (JSON.stringify(this.previousReport.columns) !== JSON.stringify(this.report.columns)) {
        this._provided.reportComment.changeColumn = true
        comment += '列、'
      }
      if (this._provided.reportComment.changeFilter || JSON.stringify(this.previousReport.filters) !== JSON.stringify(this.report.filters)) {
        this._provided.reportComment.changeFilter = true
        comment += '筛选项、'
      }
      if (this._provided.reportComment.changeAttr || JSON.stringify(this.previousReport.buttons) !== JSON.stringify(this.report.buttons)) {
        comment += '其他属性'
      }
      if (this._provided.reportComment.changeColumn || this._provided.reportComment.changeFilter || this._provided.reportComment.changeAttr) {
        comment = '更新' + comment
      }
      if (comment.charAt(comment.length - 1) === '、') {
        comment = comment.slice(0, comment.length - 1)
      }
      this.report.comment = comment
    },
    // 发布
    publish () {
      if (parseInt(this.selectPlate) !== 5) {
        this.designDialog.isResetReport = false
        if (this.saveAccomplish) {
          return false
        }
        this.handleGroupReportName()
        this.handleUpdateComment()
        this.saveAccomplish = true
        return this.isCloseReportAttr()
          .then(() => this.validate())
          .then(() => this._provided.reportService.publish())
          .then(() => this.initReport(this.report.id)) // 为了解决报表多次保存问题
          .then(() => {
            this.$message({
              message: '报表保存成功',
              center: true,
              customClass: 'message-form-save',
              type: 'success'
            })
            this.reportId = this.report.id
            this.saveAccomplish = false
            return Promise.resolve()
          })
          .catch(error => {
            this.saveAccomplish = false
            return Promise.reject(error)
          })
      } else {
        this.customPageSave()
      }
    },
    // 自定义页面保存
    customPageSave () {
      if (this.report.name.trim() === '') {
        this.changeDefinitionName()
      } else {
        this.saveAccomplish = true
        if (this.id !== '') {
          this.customPageParams.id = this.id
        } else {
          this.customPageParams.id = UUID.create()
        }
        this.customPageParams.name = this.report.name
        let data = Object.assign({}, this.customPageParams)
        data.controls = JSON.stringify(this.customPageParams.controls)
        //  51th:自定义报表缩放
        let json = {
          width: document.querySelectorAll('.custom-page-design-controls')[0].offsetWidth - 15,
          height: document.querySelectorAll('.custom-page-design-controls')[0].offsetHeight - 30
        }
        data.pageSize = JSON.stringify(json)
        return new Promise(resolve => {
          this.$axios.post(`/report-api/report/definition`, data).then(res => {
            this.$message({
              message: '报表保存成功',
              center: true,
              customClass: 'message-form-save',
              type: 'success'
            })
            this.saveAccomplish = false
            resolve()
          }).catch(res => {
            this.saveAccomplish = false
          })
        })
      }
    },
    // 校验
    validate () {
      return (() => {
        return this.basicValidate()
          .then(() => this.validateColumn())
          .then(() => this.validateSummary())
          .then(() => this.validateGroupBy())
      })().catch(error => {
        // 只有有异常信息的时候提示
        error.message && this.$message.error(error.message)
        return Promise.reject(error)
      })
    },

    // 基础校验
    basicValidate () {
      return new Promise((resolve, reject) => {
        if (this.report.mainTableId === '') {
          return reject(new Error('请先设计报表.'))
        }
        if (this.report.name === '') {
          // 如果没有填写报表名字，点击保存，需要弹出修改名字的框框
          this.changeDefinitionName()
          // 控制台报错，没有保存信息，所以加了个error
          console.error('请填写报表名称')
          return reject(new Error())
        }
        resolve()
      })
    },
    // 判断汇总行有且只有一个聚合函数
    validateSummary () {
      let groupConcatNumber = []
      let hasSummaryColumns = this.report.columns.filter(m => m.summary)
      hasSummaryColumns.forEach(el => {
        groupConcatNumber = el.summary.match(
          /(average|count|sum|max|min|group_concat|large|small)/gi
        )
        if (groupConcatNumber.length !== 1) {
          return Promise.reject(new Error('汇总行有且只有一个聚合行数.'))
        }
      })
      return Promise.resolve()
    },

    // 判断列是否包含表达式
    validateColumn () {
      return new Promise((resolve, reject) => {
        this.report.columns.forEach(m => {
          if (m.expressionText === '') {
            reject(new Error(`列${m.name}缺少表达式, 请设计后保存.`))
          }
        })
        resolve()
      })
    },

    // 判断是否启动统计依据
    validateGroupBy () {
      let reg = /^(?=(average|count|sum|max|min|group_concat|sumif|averageif|averageif|simple|large|small|median))/
      let groupByEnable = this.report.groupByEnable
      let reportColumn = this.report.columns
      let reportGroups = this.report.groupBies.map(o => o.columnId)
      if (!this.groupUseFun(reg, reportColumn, reportGroups)) {
        return
      }
      let noGroupReportColumn = reportColumn.filter(m => {
        return !reportGroups.includes(m.id)
      })
      // 判断是否全部使用统计函数

      let allGroupFunction = noGroupReportColumn.every(el =>
        reg.test(el.expressionText.toLocaleLowerCase())
      )
      let anyGroupFunction = reportColumn.some(el =>
        reg.test(el.expressionText.toLocaleLowerCase())
      )

      if (groupByEnable && !allGroupFunction) {
        return this.$confirm('', '使用统计必须使用聚合函数,是否默认替换?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'publishMessageBox',
          center: true
        }).then(() =>
          this.replaceGroupFunction(reg, reportColumn, reportGroups)
        )
      } else if (!groupByEnable && anyGroupFunction) {
        // 如果分组函数，取消了。则应该删除聚合函数
        reportColumn.forEach(column => {
          if (!reportGroups.includes(column.id)) {
            if (reg.test(column.expressionText.toLocaleLowerCase())) {
              column.expressionText = column.expressionText.match(/\(([^]+)\)/)[1]
            }
          }
        })
        return Promise.resolve()
      } else {
        return Promise.resolve()
      }
    },

    groupUseFun (reg, reportColumn, reportGroups) {
      let flag = true
      // 统计依据不能使用聚合函数
      reportColumn.forEach(el => {
        if (reportGroups.includes(el.id)) {
          // 统计依据不能使用聚合函数
          if (reg.test(el.expressionText.toLocaleLowerCase())) {
            flag = false
            this.$message.error(`统计依据 '${el.name}' 不能使用聚合函数`)
          }
        }
      })
      return flag
    },
    replaceGroupFunction (reg, columns, reportGroups) {
      columns.forEach(el => {
        if (!reportGroups.includes(el.id)) {
          if (!reg.test(el.expressionText.toLocaleLowerCase())) {
            el.expressionText = 'MAX(' + el.expressionText + ')'
          }
        }
      })
      return Promise.resolve()
    },
    closeReport () {
      this.$emit('closeReport')
    },
    // 修改报表名字
    changeDefinitionName () {
      this.dialogPage.reportName = this.report.name
      this.dialogPage.reportId = this.report.id
      this.dialogPage.dataSourceReport = this.report.dataSourceReport
      this.dialogPage.dialog = {
        visible: true,
        view: 'changeReportNameDialog',
        title: '报表名称设置',
        isPublish: false
      }
    },
    changeName () {
      this.nameAttr.name = this.report.name
      this.nameAttr.showNameInput = true
      this.$nextTick(() => {
        this.$refs.nameInput.focus()
        this.$refs.nameInput.select()
      })
    },
    saveName () {
      if (!this.report.name) {
        this.$message.info('报表名称为空')
      }
      this.nameAttr.showNameInput = false
    },
    // esc撤回
    recallName () {
      this.report.name = this.nameAttr.name
      this.nameAttr.showNameInput = false
    },
    setDefinitionName (obj) {
      this.report.name = obj.name
    },
    saveAndClose () {
      if (parseInt(this.selectPlate) === 5) {
        this.customPageSave().then(() => {
          // 自定义页面选择保存时,清空存的新旧数据,否则会二次校验数据是否一致
          this.reportValue.oldValue = ''
          this.reportValue.newValue = ''
          this.closeReport()
        })
      } else {
        this.publish().then(() => this.closeReport())
      }
    },
    drawGraph (shouldHint) {
      let data = this._provided.reportService.build()
      return this.$axios.post('/report-api/report/data/graphicReportData', data).then(res => {
        this.graphData = res.data
        shouldHint && this.$message.success('保存成功！')
        this.$nextTick(() => {
          let column = this._provided.reportService.report.columns
          if (column && column.length) {
            if (this.selectPlate === 2) {
              this.$refs.histogramReportDesign && this.$refs.histogramReportDesign.drawLine()
            } else if (this.selectPlate === 3) {
              this.$refs.pieReportDesign && this.$refs.pieReportDesign.drawLine()
            } else if (this.selectPlate === 4) {
              this.$refs.lieReportDesign && this.$refs.lieReportDesign.drawLine()
            }
          }
        })
      })
    },
    updateBillboard (data) {
      //  更新看板信息
      this.billboardData = data
    },
    //  重置报表
    async resetReport () {
      let reportName = this.report.name
      let reportId = this.report.id
      let dataSourceReport = this.report.dataSourceReport
      await this.loadReport()
      this.reload()
      this.$nextTick(() => {
        this.report.name = reportName
        this.report.id = reportId
        this.report.dataSourceReport = dataSourceReport
      })
    },
    // 处理历史数据，因为control新增有其他属性，历史数据没有，所以重新实例化
    disposeHistoryData (data) {
      let disposeData = []
      data && data.length && data.forEach(d => disposeData.push(new Controls(d)))
      return disposeData
    }
  },
  computed: {
    children: {
      get () {
        let children = this.$_.cloneDeep(
          this.report.children
        )
        if (this.report.mainTableId) {
          let mainTable = {name: '主表单', id: this.report.mainTableId}
          children.unshift(mainTable)
        }
        return children
      },
      set (val) {
        this.report.children = val
      }
    },
    getDesignName () {
      let name
      switch (this.selectPlate) {
        case 2:
          name = '柱形图设计'
          break
        case 3:
          name = '饼状图设计'
          break
        case 4:
          name = '折线图设计'
          break
      }
      return name
    }
  },
  watch: {
    'options.leftPanel': {
      // 为了新子表修改名字的时候名字没有实时更新显示
      handler (val, old) {
        this.children = this.$_.cloneDeep(this.report.children)
      },
      deep: true
    },
    '$route.path' (val, oldVal) {
      // 辅助表：/main/report-data-source-list
      this.routerList.push(val)
      // 只要切换过辅助表页面，并且当期页是报表设计页，则重新加载辅助表
      if (this.routerList.includes('/main/report-data-source-list') && val === '/main/report-design-list') {
        this.needLoadObj.value++
        this.routerList = []
      }
    }
  }
}
</script>

<style lang="scss">
  .report-design {
    height: 100%;
    background: #f8fbfe;

    .report-design-header {
      background: #fff;
      line-height: 45px;
      box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
      padding: 0 12px 0 26px;

      &:after {
        content: "";
        display: block;
        clear: both;
      }

      .report-design-header-name {
        float: left;
        height: 45px;

        .el-breadcrumb {
          height: 45px;
          line-height: 45px;

          span {
            font-size: 16px;
          }

          .el-breadcrumb__separator {
            margin-left: 2px;
          }

          &:last-child .el-breadcrumb__item {
              margin-left: -5px;

            .el-icon-edit-outline {
              margin-left: 9px;
              color: #54ABF1;
              cursor: pointer;
            }
          }
          .name-input {
            display: inline-block;
            width: 145px;
          }
        }
      }

      .header-buttons {
        float: right;

        .el-button {
          height: 26px;
          padding: 5px 9px;
        }
      }
    }

    .report-design-container {
      height: calc(100% - 50px);
      // 禁止文字被鼠标选中
      -moz-user-select: none;
      -o-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background: #f8fbfe;

      .report-component-aside {
        width: 260px;
        min-width: 260px;
        float: left;
        height: 100%;
        padding-top: 16px;
        background-color: #fff;

        .left-panel {
          height: 100%;
          margin: 8px 0 0 0;
          background: #ffffff;

          .top-panel {
            .input {
              label {
                padding-right: 13px;
              }

              padding-left: 13px;
            }

            .report-name {
              padding-top: 11px;
              padding-bottom: 11px
            }

            .attr {
              width: 170px;

              input {
                width: 100%;
                height: 28px;
                border: 1px solid #c2c3c4;
                padding: 0 15px 0 8px;
              }
            }
          }

          .bottom-panel {
            height: calc(100% - 100px);
            min-height: 470px;
            margin-top: 10px;
            border: 1px solid #c2c3c4;
            border-radius: 4px;
            margin-left: 7px;
            margin-right: 6px;
          }
          .graph-panel {
            height: calc(100% - 30px);
          }
        }

        overflow: hidden;

        .panel-switch {
          height: 100%;
          position: relative;
        }
      }

      .el-main {
        min-width: 800px;
        margin-left: 0;
        padding: 0 0 8px;
        float: right;
        width: calc(100% - 260px);

        h3 {
          padding: 10px 15px;
          background-color: #ecf5ff;
          font-size: 14px;
          font-weight: normal;
          margin-bottom: 20px;
        }

        .el-tabs {
          .addChildren {
            span {
              padding: 8px
            }
          }
        }

        .right-panel {
          height: calc(100% - 15px);
          .report-filter {
            margin: 8px 12px 12px 12px;
            background: #ffffff;
            padding-bottom: 21px;
          }

          .report-main {
            margin: 0 12px 0 12px;
            background: #ffffff;

            .report-main-title {
              height: 43px;
              padding-left: 20px;

              position: relative;
              .add-children i{
                font-size: 16px;
                color: #55ACF1;
                vertical-align: middle;
                &:active{
                 color: #388DD2
                }
              }
              .sort-column {
                position: absolute;
                right: 26px;
                top: 12px;
                color: #55ACF1;
                z-index: 1;
                cursor: pointer;
                &:active{
                 color: #388DD2
                }

                [class*="el-icon"] {
                  transform: rotate(90deg);
                  margin-right: 8px;
                }
              }

              > div {
                padding-top: 3px;
              }
              .el-tabs--card > .el-tabs__header  {
                margin: 0 2px 15px 0;
                .el-tabs__nav {
                  border: 0
                }
              }

              .el-tabs--card > .el-tabs__header .el-tabs__item {
                border-bottom: 0px solid transparent;
                border-left: 0px solid #e4e7ed;
              }

              .el-tabs__nav.is-top {
                .is-active {
                  border-bottom: 2px solid;
                }

                > div {
                  &::before {
                    content: "";
                    width: 1px;
                    height: 14px;
                    background: #e4f0f9;
                    position: absolute;
                    left: 0px;
                    top: 14px;
                  }

                  &:first-child {
                    &::before {
                      width: 2px;
                      background: #54abf1;
                    }
                  }

                  &:nth-child(n+2) {
                    font-size: 12px;
                  }

                  &:last-child {
                    border-bottom: 0;
                  }
                }
              }
            }

            .report-main-content {
              height: 128px;
            }
          }
          .graph-main {
            margin: 0 12px 0 32px;
            background: #ffffff;
            height: calc(100% - 210px);
            .graph-title {
              position: relative;
              padding-left: 9px;
              &::before {
                content: "";
                width: 2px;
                height: 14px;
                background: #54abf1;
                position: absolute;
                left: 0px;
                top: 3px;
              }
            }
            .graph-map {
              height: calc(100% - 20px);
            }
          }
          .billboard-main{
            height: 100%;
            padding-left: 10px;
            padding-top: 25px;
            overflow: hidden;
            .billboard-map{
              height: 100%;
              overflow: auto;
            }
          }
          h3 {
            background-color: transparent;
            border-bottom: 1px solid #e4e7ed;
          }

          .add-button {
            margin-top: 20px;
          }
        }
      }
    }
  }

  .el-message-box.publishMessageBox {
    .el-message-box__btns {
      float: left;
      position: relative;
      left: 50%;
      margin-left: -148px;

      .el-button {
        width: 104px;
        height: 30px;
        padding: 0;
      }

      .el-button {
        float: right;

        &.el-button--primary {
          margin-right: 49px;
        }
      }
    }
  }

  .el-message.message-save {
    min-width: 176px;
    background: rgba(153, 153, 153, .8);
    padding: 17px 15px 17px 20px;
    top: 50%;
    border: none;
    margin-top: -25px;

    [class*="el-icon"], .el-message__content {
      color: #fff;
    }
  }
  .el-message.el-message--info.is-center.without-execute-dialog{
    min-width: 136px;
    min-height: 36px;
    height: 36px;
    position: fixed;
    left: calc(50% + 100px);
    top: 40%;
    background-color: #29282E;
    >p{
      font-size: 12px;
      color: #FFFFFF;
    }
    >i{
      display: none;
    }
}

  .el-message.message-form-save {

    .el-icon-success,
    .el-message__content {
      color: #409EFF;
    }

    &.el-message--success {
      background-color: transparent;
      border-color: transparent;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/report-design.vue